import { render, staticRenderFns } from "./cModalBedGroup.vue?vue&type=template&id=1ce83545&scoped=true"
import script from "./cModalBedGroup.vue?vue&type=script&lang=js"
export * from "./cModalBedGroup.vue?vue&type=script&lang=js"
import style0 from "./cModalBedGroup.vue?vue&type=style&index=0&id=1ce83545&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce83545",
  null
  
)

export default component.exports